import * as React from 'react';
import {BlogPostsContext} from './BlogManagerContainer';
import BlogPostsSearch from '../../components/blog/BlogPostsSearch';
export type BlogManagerProps = {
  children?: React.ReactNode;
};
const BlogManagerBlogSearchContainer = ({
  children,
}: BlogManagerProps): JSX.Element => {
  const blogPostsContext = React.useContext(BlogPostsContext);
  const resultContext = 'Search';
  const resultType = 'List';
  return (
    <>
      <BlogPostsSearch
        blogPosts={blogPostsContext.state.blogPosts}
        resultType={resultType}
        resultContext={resultContext}
        blogPostsDispatch={blogPostsContext.dispatchBlogPosts}
      />
    </>
  );
};

export default BlogManagerBlogSearchContainer;
